/**
 * Polski katalog copywritingu dla funkcji handlu
 * (`@gamecodex/world-ui` → `features/commerce`).
 *
 * Klucze odbijają `t('commerce.*')` z komponentów React funkcji.
 * Wartości to dokładne angielskie ciągi znaków wyodrębnione podczas przeglądu i18n.
 */
export const commercePl = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'Zgłoś swoją bibliotekę',
  'commerce.dtrpg.seoDescription': 'Zaimportuj swoją bibliotekę DriveThruRPG i zgłoś swoje pliki PDF Grymwyrd.',
  'commerce.dtrpg.heading': 'Zgłoś swoją bibliotekę',
  'commerce.dtrpg.intro':
    'Kupiłeś Grymwyrd na DriveThruRPG lub wspomogłeś kampanię? Zaloguj się adresem e-mail zakupu, aby zaimportować swoją bibliotekę i zgłosić swoje kopie.',
  'commerce.dtrpg.sendLinkError': 'Nie mogliśmy wysłać linku do logowania. Spróbuj za chwilę.',
  'commerce.dtrpg.checkInboxPrefix': 'Sprawdź skrzynkę odbiorczą pod adresem',
  'commerce.dtrpg.checkInboxSuffix':
    'Jeśli ten adres e-mail wspomógł lub kupił Grymwyrd, link do logowania jest już w drodze — kliknij go, aby powrócić tutaj i zgłosić swoją bibliotekę.',
  'commerce.dtrpg.linkAutoSignIn': 'Link loguje Cię automatycznie — hasło nie jest potrzebne.',
  'commerce.dtrpg.purchaseEmailLabel': 'Twój adres e-mail zakupu / zobowiązania',
  'commerce.dtrpg.sendingLink': 'Wysyłanie linku…',
  'commerce.dtrpg.emailLinkCta': 'Wyślij mi link do logowania',
  'commerce.dtrpg.signedInAs': 'Zalogowany jako',
  'commerce.dtrpg.signOut': 'Wyloguj się',
  'commerce.dtrpg.dtrpgEmailLabel': 'Adres e-mail DriveThruRPG',
  'commerce.dtrpg.dtrpgEmailOptional': '(opcjonalnie — jeśli różni się od powyższego)',
  'commerce.dtrpg.dtrpgEmailHelp': 'Używamy tego do dopasowania zakupów z DriveThruRPG podczas przyznawania biblioteki.',
  'commerce.dtrpg.libraryHeading': 'Twoja biblioteka Grymwyrd',
  'commerce.dtrpg.noTitles': 'Żadne importowalne tytuły nie są jeszcze skonfigurowane.',
  'commerce.dtrpg.claimNotInLibrary':
    'Ten tytuł nie znajduje się jeszcze w Twojej bibliotece. Upewnij się, że używałeś prawidłowego adresu e-mail zakupu.',
  'commerce.dtrpg.claimSessionExpired': 'Sesja wygasła — zaloguj się ponownie.',
  'commerce.dtrpg.claimError': 'Nie można zgłosić tego tytułu w tej chwili. Spróbuj ponownie.',
  'commerce.dtrpg.preparingCopy': 'Przygotowywanie kopii…',
  'commerce.dtrpg.download': 'Pobierz',
  'commerce.dtrpg.preparing': 'Przygotowywanie…',
  'commerce.dtrpg.claiming': 'Zgłaszanie…',
  'commerce.dtrpg.claim': 'Zgłoś',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'Nie można otworzyć kasy. Spróbuj ponownie za chwilę.',
  'commerce.paywall.signInToPurchase': 'Zaloguj się, aby ukończyć ten zakup.',
  'commerce.paywall.vaultSealed': 'Skarbiec kupca jest teraz zamknięty — spróbuj ponownie za chwilę.',
  'commerce.paywall.signInToUnlock': 'Zaloguj się, aby odblokować',
  'commerce.paywall.comingSoonTitle': 'Ten zakup wkrótce się pojawi',
  'commerce.paywall.priceComingSoon': '{price} — wkrótce',
  'commerce.paywall.comingSoon': 'Wkrótce',
  'commerce.paywall.openingVault': 'Otwieranie skarbca…',
  'commerce.paywall.unlockPrice': 'Odblokuj — {price}',
  'commerce.paywall.unlock': 'Odblokuj',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': 'Zainstalowano „{name}" na stole.',
  'commerce.marketplace.installNotOwned': 'Nie posiadasz jeszcze tego pakietu — kupowanie pakietów wkrótce się pojawi.',
  'commerce.marketplace.installHostOnly': 'Tylko gospodarz stołu może zainstalować pakiet.',
  'commerce.marketplace.installError': 'Nie można zainstalować tego pakietu. Spróbuj ponownie.',
  'commerce.marketplace.installed': 'Zainstalowano',
  'commerce.marketplace.installing': 'Instalowanie…',
  'commerce.marketplace.installOnTable': 'Zainstaluj na stole',
  'commerce.marketplace.seoTitle': 'Rynek — Pakiety',
  'commerce.marketplace.seoDescription':
    'Przeglądaj i instaluj pakiety treści twórców — mapy, sceny, materiały i szablony — na swoich stołach.',
  'commerce.marketplace.eyebrow': 'Rynek',
  'commerce.marketplace.heading': 'Pakiety treści',
  'commerce.marketplace.intro':
    'Mapy, sceny, materiały i szablony szybkiego startu — zainstaluj je na swoich stołach jednym klikiem.',
  'commerce.marketplace.installingOnto': 'Instalowanie na stole {tableId}.',
  'commerce.marketplace.signInHeading': 'Zaloguj się, aby zobaczyć swoje pakiety',
  'commerce.marketplace.signInBlurb': 'Katalog pakietów jest powiązany z Twoim kontem twórcy.',
  'commerce.marketplace.signIn': 'Zaloguj się',
  'commerce.marketplace.loading': 'Przywołujemy Twoje pakiety…',
  'commerce.marketplace.noPacksHeading': 'Brak pakietów',
  'commerce.marketplace.noPacksBlurb':
    'Nie opublikowałeś jeszcze żadnych pakietów. Publiczny rynek do przeglądania pakietów innych twórców wkrótce się pojawi.',
  'commerce.marketplace.footer': 'Przeglądanie pakietów innych twórców i pakietów płatnych już wkrótce.',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': 'Stoły tylko dla abonentów',
  'commerce.subscriber.perk1Blurb': 'Zasiądź przy stołach, które Twoi ulubieni gospodarze rezerwują dla abonentów.',
  'commerce.subscriber.perk2Title': 'Wcześna i ekskluzywna treść',
  'commerce.subscriber.perk2Blurb': 'Zdobądź rozdziały kampanii, sceny i materiały przed innymi.',
  'commerce.subscriber.perk3Title': 'Wyróżnienie abonenta',
  'commerce.subscriber.perk3Blurb': 'Znak pozycji na Twoim profilu i przy stole.',
  'commerce.subscriber.seoTitle': 'Korzyści abonenta',
  'commerce.subscriber.seoDescription':
    'Zostań abonentem i otrzymaj dostęp do ekskluzywnych stołów, wczesnej treści i wyróżnienia abonenta.',
  'commerce.subscriber.heading': 'Zostań abonentem',
  'commerce.subscriber.intro':
    'Wspomóż gospodarzy i twórców, których kochasz — i odblokuj korzyści, które rezerwują dla swojego wewnętrznego koła.',
  'commerce.subscriber.activeHeading': 'Jesteś abonentem',
  'commerce.subscriber.activeBlurb':
    'Twoje korzyści są aktywne. Poszukaj herb abonenta na stołach, do których możesz dołączyć.',
  'commerce.subscriber.findTable': 'Znajdź stół abonenta',
  'commerce.subscriber.paywallTitle': 'Abonent Grymwyrd',
  'commerce.subscriber.paywallBlurb':
    'Odblokuj stoły tylko dla abonentów, wczesną treść i swoje wyróżnienie abonenta.',
  'commerce.subscriber.paywallPrice': 'od 5 USD/mies.',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'Nie można otworzyć kasy. Spróbuj ponownie za chwilę.',
  'commerce.ticket.signInToBuy': 'Zaloguj się, aby kupić miejsce przy tym stole.',
  'commerce.ticket.boxOfficeClosed': 'Kasa jest teraz zamknięta — spróbuj ponownie za chwilę.',
  'commerce.ticket.seoTitle': 'Kup miejsce',
  'commerce.ticket.seoDescription': 'Zarezerwuj miejsce przy stole ze sprzedawanymi biletami.',
  'commerce.ticket.eyebrow': 'Stół ze sprzedawanymi biletami',
  'commerce.ticket.heading': 'Zarezerwuj swoje miejsce',
  'commerce.ticket.loading': 'Ładowanie stołu…',
  'commerce.ticket.notFoundHeading': 'Nie znaleziono stołu',
  'commerce.ticket.notFoundBlurb': 'Ten stół mógł się zamknąć, lub jego drzwi nigdy nie były otwarte.',
  'commerce.ticket.backToLobby': 'Wróć do holu',
  'commerce.ticket.freeHeading': 'Ten stół jest darmowy do dołączenia',
  'commerce.ticket.freeBlurb': 'Bilet nie jest wymagany — przysuń sobie krzesło.',
  'commerce.ticket.goToLobby': 'Przejdź do holu',
  'commerce.ticket.untitledTable': 'Stół bez nazwy',
  'commerce.ticket.seatPrice': 'Cena miejsca',
  'commerce.ticket.spectatorsNote': 'Obserwatorzy muszą również posiadać bilet do tego stołu.',
  'commerce.ticket.paymentReceived': 'Płatność otrzymana — Twoje miejsce jest zarezerwowane. Przejdź do holu, aby je zabrać.',
  'commerce.ticket.signInToBuySeat': 'Zaloguj się, aby kupić miejsce',
  'commerce.ticket.openingBoxOffice': 'Otwieranie kasy…',
  'commerce.ticket.buySeatPrice': 'Kup miejsce — {price}',
  'commerce.ticket.comingSoonTitle': 'Sprzedaż biletów wkrótce się pojawi',
  'commerce.ticket.ticketingComingSoon': 'Sprzedaż biletów wkrótce',
  'commerce.ticket.comingSoonFooter': 'Płatne miejsca już prawie gotowe. Na razie poproś gospodarza o darmowe zaproszenie.',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'Tylko gospodarz stołu może zarządzać celami.',
  'commerce.tip.errHostOnlyBounty': 'Tylko gospodarz stołu może zarządzać nagrodami.',
  'commerce.tip.errMaxGoal': 'Osiągnąłeś maksymalną liczbę celów dla tego stołu.',
  'commerce.tip.errMaxBounty': 'Osiągnąłeś maksymalną liczbę nagród dla tego stołu.',
  'commerce.tip.errMissingGoal': 'Tamtemu celowi brakuje wymaganych szczegółów.',
  'commerce.tip.errMissingBounty': 'Tamtej nagrodzie brakuje wymaganych szczegółów.',
  'commerce.tip.errSignIn': 'Zaloguj się jako gospodarz, aby zarządzać tym stołem.',
  'commerce.tip.errSaveFailedGoal': 'Nie można zapisać celu. Spróbuj ponownie.',
  'commerce.tip.errSaveFailedBounty': 'Nie można zapisać nagrody. Spróbuj ponownie.',
  'commerce.tip.goalValidation': 'Dodaj etykietę i dodatni cel dolara.',
  'commerce.tip.goalAdded': 'Cel „{label}" dodany.',
  'commerce.tip.goalLabelPlaceholder': 'Etykieta celu (np. Przywołaj bossa)',
  'commerce.tip.targetPlaceholder': 'Cel $',
  'commerce.tip.cuePlaceholder': 'Wskazówka po osiągnięciu (np. fanfara)',
  'commerce.tip.addGoal': 'Dodaj cel',
  'commerce.tip.bountyValidation': 'Dodaj etykietę, dodatni cel i wyzwalacz.',
  'commerce.tip.bountyAdded': 'Nagroda „{label}" dodana.',
  'commerce.tip.bountyLabelPlaceholder': 'Etykieta nagrody (np. Naturalny 20 ratuje drużynę)',
  'commerce.tip.triggerPlaceholder': 'Wyzwalacz (np. naturalny 20)',
  'commerce.tip.addBounty': 'Dodaj nagrodę',
  'commerce.tip.signInToManage': 'Zaloguj się, aby zarządzać tym stołem.',
  'commerce.tip.bountyClaimed': 'Nagroda „{label}" odebrania.',
  'commerce.tip.seoTitle': 'Cele napiwków i nagrody',
  'commerce.tip.seoDescription': 'Ustaw cele napiwków i nagrody dla swojego stołu.',
  'commerce.tip.backToLobby': 'Wróć do holu',
  'commerce.tip.heading': 'Cele napiwków i nagrody',
  'commerce.tip.intro':
    'Ustaw cele i nagrody dla swojego stołu. Gdy kubek się przepełni, wskazówka zadziała dla Twojej publiczności. Wyświetlacz na transmisji obsługiwany jest przez nakładkę transmisji.',
  'commerce.tip.loading': 'Odczytywanie rejestru…',
  'commerce.tip.loadErrorTitle': 'Nie można załadować rejestru',
  'commerce.tip.raisedSoFar': 'Zebrano do tej pory:',
  'commerce.tip.tipGoalsHeading': 'Cele napiwków',
  'commerce.tip.noGoals': 'Brak celów — dodaj swój pierwszy poniżej.',
  'commerce.tip.reachedAria': 'osiągnięte',
  'commerce.tip.bountiesHeading': 'Nagrody',
  'commerce.tip.noBounties': 'Brak nagród — dodaj swoją pierwszą poniżej.',
  'commerce.tip.whenLabel': '· gdy: {trigger}',
  'commerce.tip.claimed': 'Odebrano',
  'commerce.tip.claimTitleReady': 'Oznacz tę nagrodę jako odebrana',
  'commerce.tip.claimTitleNotFunded': 'Jeszcze nie sfinansowano',
  'commerce.tip.claim': 'Odbierz',
} as const
